import { fireRefundGAEvent } from '@global/gtm/base';
import OrderGTMEvent from '@global/gtm/class/orderClass';

export default function fireCancelOrderGAEvent(orderPayload) {
  window.dataLayer = window.dataLayer || [];

  const { orderID, orderItems } = orderPayload;
  const mapOrderItem = OrderGTMEvent.getOderInfo(orderItems);

  fireRefundGAEvent({
    transactionID: orderID,
    value: orderItems.PayPrice, // 商品應付款金額
    shipping: orderItems.ShippingCost,
    items: mapOrderItem,
  });
}
